module.exports = __webpack_public_path__ + "static/tusas2-4d7f759792f503227ef02666030c1eec.png";